<dx-data-grid
  [dataSource]="learningPathsProgressData"
  [showBorders]="false"
  [showColumnLines]="false"
  [showRowLines]="true"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
  [allowColumnResizing]="false"
  [columnResizingMode]="'nextColumn'"
  [paging]="{ enabled: false }"
  [scrolling]="{ mode: 'standard', showScrollbar: 'always' }"
>
  <dxi-column
    *ngFor="let column of learningPathsProgressColumns"
    [caption]="column.caption"
    [dataField]="column.dataField"
    [allowEditing]="false"
  ></dxi-column>
</dx-data-grid>
